import { ReqBodyType } from './types/reqBody';
import HttpClient from './utils/HttpClient';

interface IVtItensService {
  codUsu?: number;
  perfilUsu?: number;
  token: string;
  tipoAcao?: number;  codEnvelop?: number;
  reqBody?: ReqBodyType;
  consultCode?: string;
}

class VtItensService {
  private readonly httpClient: HttpClient;
  constructor() {
    this.httpClient = new HttpClient(process.env.REACT_APP_PATHNAME ?? '');
  }

  listVtItens = async ({
    codUsu,
    perfilUsu,
    tipoAcao = 23,
    token,
  }: IVtItensService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_ItensVT?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoAcao=${tipoAcao}`,
    });
  };

  createOrUpdateVtItem = async ({
    reqBody,
    token,
  }: IVtItensService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_ItensVT',
      reqBody,
    });
  };

  changeVtItemStatus = async ({
    reqBody,
    token,
  }: IVtItensService) => {
    return this.httpClient.put({
      token,
      path: '/api/SMob_ItensVT',
      reqBody,
    });
  };

  createOrUpdateOneOrManyRelations = async ({
    reqBody,
    token,
  }: IVtItensService) => {
    return this.httpClient.post({
      token,
      path: '/api/SMob_Envelopadoras',
      reqBody,
    });
  };

  listVtItensRelations = async ({
    codUsu,
    perfilUsu,
    tipoAcao = 25,
    codEnvelop,
    token,
  }: IVtItensService) => {
    return this.httpClient.get({
      token,
      path: `/api/SMob_Envelopadoras?codUsu=${codUsu}&perfilUsu=${perfilUsu}&tipoAcao=${tipoAcao}&codEnvelop=${codEnvelop}`,
    });
  };

  getPendingRelations = async ({
    consultCode,
  }: IVtItensService) => {
    return this.httpClient.get({
      token: process.env.REACT_APP_GENERAL_API_TOKEN as string,
      path: `/api/ItensVT_Envelopadora?consulta=${consultCode}`,
    });
  };

  createPendingRelations = async ({
    reqBody,
  }: IVtItensService) => {
    return this.httpClient.post({
      token: process.env.REACT_APP_GENERAL_API_TOKEN as string,
      path: '/api/ItensVT_Envelopadora',
      reqBody,
    });
  };
}

export default new VtItensService();
